const ISO12100_LEVEL_LABELS = {
  1: 'Baixo',
  2: 'Médio',
  3: 'Alto',
  4: 'Muito Alto',
}

const ISO12100_LEVEL_COLORS = {
  1: '#37CB39',
  2: '#FDFF04',
  3: '#FD750B',
  4: '#FE0501',
}

export { ISO12100_LEVEL_LABELS, ISO12100_LEVEL_COLORS }
